// Import uniwersalnego wrappera do komunikacji z API (obsługuje GET/POST/DELETE itd.)
import { fetchWrapper } from "@/helpers/fetch-wrapper";

// Klasa obsługująca operacje na czarnej liście pojazdów (Black List)
class BlackListsService {

  /**
   * Dodaje nowy numer rejestracyjny do czarnej listy (Black List).
   * @param {string} licensePlate - Numer rejestracyjny pojazdu.
   * @param {string} description - Opis pojazdu.
   * @param {number|null} userId - ID przypisanego użytkownika (opcjonalnie).
   * @returns odpowiedź z API lub undefined jeśli brak wymaganych danych.
   */
  async postNewPlate(licensePlate, description, userId) {
    // Walidacja - nie wysyłaj zapytania jeśli brakuje tablicy lub opisu.
    if (!licensePlate || !description) {
      return;
    }

    // Wywołanie endpointu POST do /wanted-plates – zapisanie pojazdu na czarnej liście
    const response = await fetchWrapper.post(
      process.env.VUE_APP_API_URL + '/wanted-plates',
      {
        plateLpr: licensePlate,
        typeOfList: 0, // 0 = czarna lista
        description: description,
        userId: userId // ID użytkownika, może być null
      }
    );
    return response;
  }

  /**
   * Pobiera listę wszystkich użytkowników (np. do przypisania pojazdu).
   * Limit 1000 użytkowników na jedną stronę.
   */
  async getUsers() {
    return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/users?page=1&limit=1000`);
  }

  /**
   * Pobiera wszystkie pojazdy z czarnej listy (paginacja po 10, sortowanie malejąco).
   */
  async getAll() {
    try {
      // Parametry GET: tylko czarna lista (typeOfList=0), sortuj DESC, page=1, limit=10
      const params = new URLSearchParams({
        typesOfLists: [0], // tylko czarna lista
        orderDirection: 'desc',
        page: 1,
        limit: 10
      });

      // Pobranie pojazdów z endpointu /wanted-plates
      const response = await fetchWrapper.get(
        `${process.env.VUE_APP_API_URL}/wanted-plates?${params.toString()}`
      );

      console.log(response);

      return response;
    } catch (error) {
      console.error('Error fetching vehicles:', error);
    }
  }

  /**
   * Usuwa pojazd z czarnej listy po ID.
   * @param {number} id - ID pojazdu.
   */
  async delete(id) {
    try {
      const response = await fetchWrapper.delete(
        `${process.env.VUE_APP_API_URL}/wanted-plates/${id}`
      );
      return response;
    } catch (error) {
      console.error('Error deleting vehicle:', error);
    }
  }
}

// Eksport instancji serwisu do użycia w komponentach
export default new BlackListsService();
